import CollapsibleGroup from './component'
export default CollapsibleGroup
